<template>
    <v-flex>
        <v-flex xs12>
            <v-checkbox
                    v-model="allSelected"
                    data-qe-id="selected-topics_select-all"
                    :label="speakerRegistrationConstants.ALL_CATEGORIES">
            </v-checkbox>
        </v-flex>
        <v-flex v-for="(childTopic, k) in topic.childTopics" :key="k">
            <v-checkbox
                    v-model="topic.selectedTopics"
                    :data-qe-id="`selected-child-topics_index_${k}`"
                    multiple
                    @change="onTopicChange"
                    :label="childTopic.topicName"
                    :value="childTopic"></v-checkbox>
        </v-flex>
    </v-flex>
</template>

<script>
    import { speakerRegistrationConstants } from "./speakerConstant";

    export default {
        data() {
            return {
                speakerRegistrationConstants,
            };
        },
        props: {
            topic: {
                type: Object,
                required: true,
            },
            topicChanged: {
                type: Function,
            },
        },
        computed: {
            allSelected: {
                get() {
                    return this.topic.childTopics && this.topic.selectedTopics &&
                        this.topic.childTopics.length === this.topic.selectedTopics.length;
                },
                set(value) {
                    this.topic.selectedTopics = [];
                    if (value) {
                        this.topic.selectedTopics = JSON.parse(JSON.stringify(this.topic.childTopics));
                    }
                    if (this.topicChanged) {
                        this.topicChanged();
                    }
                },
            },
        },
        methods: {
            onTopicChange() {
                if (this.topicChanged) {
                    this.topicChanged();
                }
            },
        },
    };
</script>
